import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import colors from 'shared-assets/lib/colors';
import styles from 'shared-assets/lib/styles';

const SelectStyled = styled.select`
  && {
    width: 100%;
    height: 2rem;
    border-radius: ${styles.borderRadius};
    border: ${styles.border.default};
    outline: none;
    font-size: 1rem;
    line-height: 1.5rem;
    padding: ${styles.padding};
    color: ${colors.textColorPrimary};

    &:focus {
      border: ${styles.border.focus};
    }

    ${props => {
      if (!props.status) return ``;

      return `
      border-color:${colors[props.status]};
    `;
    }};
  }

  &:required:invalid {
    border-color: ${props => props.invalidColor};
  }
`;

export default class Select extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visited: false };
  }

  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    onBlur: PropTypes.func,
    visited: PropTypes.bool,
  };

  static defaultProps = {
    children: [],
    onBlur: undefined,
    visited: undefined,
  };

  onBlur = event => {
    this.setState({ visited: true });
    if (!!this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  render() {
    const { children, onBlur, visited, ...rest } = this.props;
    return (
      <SelectStyled
        onBlur={this.onBlur}
        {...rest}
        invalidColor={this.state.visited && colors.error}
      >
        {this.props.children}
      </SelectStyled>
    );
  }
}
